import { PurchaseHistoryData } from '@/features/games/shared/types/purchase-history.types';

export async function fetchPurchaseHistory(): Promise<PurchaseHistoryData> {
  const response = await fetch('/api/game/purchase-history', { cache: 'no-store' });
  if (!response.ok) {
    throw new Error(`Could not fetch member token ${response.status}`);
  }
  return (await response.json()) as PurchaseHistoryData;
}

const TTL_MS = 5 * 60 * 1000; // 5 minutes
let cache: PurchaseHistoryData | null = null;
let expiresAt = 0;
let inflight: Promise<PurchaseHistoryData> | null = null;

export async function fetchPurchaseHistoryCached(
  forceRefresh = false,
): Promise<PurchaseHistoryData> {
  const now = Date.now();
  const isValid = !forceRefresh && cache && expiresAt > now;

  if (isValid) {
    return cache!;
  }

  if (inflight) {
    return inflight;
  }

  inflight = (async () => {
    try {
      const tokens = await fetchPurchaseHistory();
      cache = tokens;
      expiresAt = Date.now() + TTL_MS;
      return tokens;
    } catch (err) {
      console.error('Failed to fetch purchase history(cached):', err);
      throw err;
    } finally {
      inflight = null;
    }
  })();

  return inflight;
}

export function bustPurchaseHistoryCache() {
  cache = null;
  expiresAt = 0;
  inflight = null;
}
